module.exports = __webpack_public_path__ + "static/ufc-24hours-d0af6e7c29c018829eeeac6b6fdff6ef.png";